import { render, staticRenderFns } from "./OnboardingSelectBlocks.vue?vue&type=template&id=5d94bad6&lang=pug"
import script from "./OnboardingSelectBlocks.vue?vue&type=script&lang=js"
export * from "./OnboardingSelectBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports